<div [innerHTML]="templateContent"></div>
